import React, { useEffect, useState } from "react";
import PLogo from "./PLogo.png";
import { IoMdOpen } from "react-icons/io";
import { MdLogout } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const PracticeHeader = () => {
  const navigate = useNavigate();
  const LoginDetails = useSelector((state) => state.userDetailsData.LoginDetails);

  const Logoutuser = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/PracticeTest/PracticeLogin", { replace: true });
    window.location.reload();
  }
  return (
    <>
      <div className="dflex JSBetween p-3 alignitems" style={{ boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.15)", backgroundColor: "#FFF" }}>
        <img src={PLogo} alt="Practice Logo" />
        {LoginDetails?.Name &&
          <div className="User-details Header-icons dflex  alignitems">
            <span> {LoginDetails?.Name}</span>
            <MdLogout title="Logout" className="User-icon" onClick={() => Logoutuser()} />
          </div>}
      </div>
    </>
  )
}
export default PracticeHeader;